module.exports = __webpack_public_path__ + "img/folder-icon.7135c57a.svg";